/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing proxy related components.
 * @module AviProxyModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';

import { AviProxyComponent, SplitProxyConfigurationComponent } from './components';

const components = [
    AviProxyComponent,
    SplitProxyConfigurationComponent,
];

@NgModule({
    declarations: [
        ...components,
    ],
    imports: [
        AviFormsModule,
        BrowserAnimationsModule,
        CommonModule,
        SharedModule,
    ],
    exports: [
        AviProxyComponent,
        SplitProxyConfigurationComponent,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA,
    ],
})
export class AviProxyModule {}
